<script setup lang="ts">
import type { RouteLocationRaw } from "vue-router"

const { data, suspense } = useMarketing(selectPages)

await suspense()

interface Link {
  to: RouteLocationRaw
  title: string
  customClass?: string
}

const { public: config } = useRuntimeConfig()

const links = computed<Link[]>(() => {
  const { om } = getLocationIdsFromSlugs(config)

  const dynamicLinks = (data.value ?? []).map<Link>((page) => {
    const path = sanitizeForUrl(page.title)
    return {
      title: page.title,
      to: {
        name: "om-path",
        params: { path },
        query: path in om ? undefined : { side: page.id },
      },
    }
  })

  return [
    ...dynamicLinks,
    {
      title: "Studentliv",
      to: { name: "studentliv-path", params: { path: "faa-vaare-beste-tips-og-triks-til-eksamen" } },
    },
    {
      title: "Universitetsforlaget",
      to: "https://www.uf.no",
    },
    {
      title: "Administrer Informasjonskapsler",
      to: "#",
      customClass: "cky-banner-element",
    },
  ]
})
</script>

<template>
  <footer class="flex w-screen flex-col items-center justify-center overflow-hidden bg-[--theme-darker] py-16 md:px-24">
    <div class="flex h-full w-[90vw] max-w-[100em] flex-col items-start justify-center gap-8 md:w-full md:flex-row md:items-center md:justify-between">
      <div class="flex flex-col justify-center gap-6">
        <ULogo
          aschehoug
          header-level="h2"
          :dark="false"
        />
        <address class="font-national2 text-text-md-mobile not-italic text-[--theme-lighter] md:text-text-md-desktop">
          Aschehoug AS<br />Org. nr 935 302 137<br />Sehesteds
          gate 3, 0164 Oslo
        </address>
      </div>
      <ul class="grid gap-3 md:grid-flow-col md:grid-rows-4 md:gap-y-4 lg:gap-x-8">
        <li
          v-for="link in links"
          :key="link.title"
          :class="link?.customClass"
          class="flex items-center pt-2 md:pt-0"
        >
          <!-- eslint-disable tailwindcss/no-contradicting-classname -->
          <NuxtLink
            :to="link.to"
            active-class="!decoration-[--theme-light] !text-[--theme-light]"
            class="font-national2 text-label-md-mobile text-platform-white underline decoration-[--theme-lighter] decoration-2 underline-offset-8 hover:text-[--theme-light] hover:decoration-[--theme-light] md:text-label-md-desktop"
          >
            {{ link.title }}
          </NuxtLink>
          <!-- eslint-enable -->
        </li>
      </ul>
    </div>
  </footer>
</template>
